export class Gradient {
    constructor(startRGB = '', endRGB = '', maxNum = 10) {
        this.startRGB = startRGB;
        this.endRGB = endRGB;
        this.maxNum = maxNum;
    }

    // Set the beginning and end of the gradient
    setColorGradient = (startColor, endColor) => {
        this.startRGB = this.#toRGBObject(startColor);
        this.endRGB = this.#toRGBObject(endColor);
        return this;
    };

    // The number of colors to compute
    setNumberOfColors = (maxNumber) => {
        if (!isNaN(maxNumber) && maxNumber >= 0) {
            this.maxNum = maxNumber;
        }
        return this;
    };

    // Get generated colors
    getColors = () => {
        const gradientColorsArray = [];
        for (let i = 0; i < this.maxNum; i++) {
            gradientColorsArray.push(this.#getColour(0, (this.maxNum - 1), i));
        }
        return gradientColorsArray;
    };

    // private methods
    #toRGBObject = rgbStr => {
        const [r, g, b] = rgbStr.match(/\d+/g).map(Number);
        return { r, g, b };
    };

    #getIncrement = (value, fromSource, toSource, fromTarget, toTarget) => {
        let increment = (value - fromSource) / (toSource - fromSource) * (toTarget - fromTarget) + fromTarget;
        if (isNaN(increment)) {
            increment = 0;
        }
        return increment;
    };

    #getColour = (min, max, value) => {
        const incrementPercentage = this.#getIncrement(value, min, max, 0, 1);

        let diffRed = this.endRGB.r - this.startRGB.r;
        let diffGreen = this.endRGB.g - this.startRGB.g;
        let diffBlue = this.endRGB.b - this.startRGB.b;

        diffRed = (diffRed * incrementPercentage) + this.startRGB.r;
        diffGreen = (diffGreen * incrementPercentage) + this.startRGB.g;
        diffBlue = (diffBlue * incrementPercentage) + this.startRGB.b;

        return `rgba(${Math.round(diffRed)}, ${Math.round(diffGreen)}, ${Math.round(diffBlue)}, 1)`;
    };
}
